import React from 'react';
import { SearchField } from './search-field.component.js';
import { TextField } from './text-field.component.js';
export const Input = React.forwardRef((props, ref) => {
    if (props.variant === 'search') {
        return React.createElement(SearchField, { ...props, ref: ref });
    }
    return React.createElement(TextField, { ...props, ref: ref });
});
//# sourceMappingURL=input.component.js.map